// Default to local backend (port 5001) for development since the mobile app uses 5001
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
//const API_URL = 'http://localhost:5005/api';

export const ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_URL}/auth/login`,
    REGISTER: `${API_URL}/auth/register`,
    ME: `${API_URL}/auth/me`,
    FORGOT_PASSWORD: `${API_URL}/auth/forgot-password`,
    VERIFY_OTP: `${API_URL}/auth/verify-otp`,
    RESET_PASSWORD: `${API_URL}/auth/reset-password`,
  },
  DASHBOARD: {
    STATS: `${API_URL}/analytics/dashboard`,
    RECENT_BOOKINGS: `${API_URL}/bookings/debug/all`,
  },
  PROVIDERS: {
    base: `${API_URL}/providers`,
    APPROVALS: `${API_URL}/providers/pending`,
  },
  CUSTOMERS: {
    base: `${API_URL}/customers`,
    stats: `${API_URL}/customers/stats`,
  },
  BOOKINGS: {
    base: `${API_URL}/bookings`,
    stats: `${API_URL}/bookings/stats`,
  },
  SERVICES: {
    base: `${API_URL}/services`,
    stats: `${API_URL}/services/stats`,
    CATEGORIES: `${API_URL}/categories`,
  },
  PAYMENTS: {
    base: `${API_URL}/payments`,
    stats: `${API_URL}/payments/stats`,
  },
  PAYOUTS: {
    base: `${API_URL}/payouts`,
    stats: `${API_URL}/payouts/stats`,
  },
  DISPUTES: {
    base: `${API_URL}/disputes`,
    stats: `${API_URL}/disputes/stats`,
  },
  PROMOTIONS: {
    base: `${API_URL}/promotions`,
    stats: `${API_URL}/promotions/stats`,
  },
  SETTINGS: {
    base: `${API_URL}/settings`,
    commission: {
      default: `${API_URL}/settings/commission/default`,
    },
    gateway: {
      customer: `${API_URL}/settings/gateway/customer`,
      provider: `${API_URL}/settings/gateway/provider`,
    },
    notifications: `${API_URL}/settings/notifications`,
    APP_CONFIG: `${API_URL}/settings/app-config`,
  },
  CONTENT: {
    FAQS: `${API_URL}/content/faqs`,
    POLICIES: `${API_URL}/content/policies`,
    HELP: `${API_URL}/content/help-articles`,
    TEMPLATES: `${API_URL}/content/notification-templates`,
  },
  AUDIT: {
    LOGS: `${API_URL}/audit-log`,
    STATS: `${API_URL}/audit-log/stats`,
    SEED: `${API_URL}/audit-log/seed`,
  },
  LOYALTY: {
    ADMIN_SETTINGS: `${API_URL}/loyalty/admin/settings`,
    ADMIN_SEED: `${API_URL}/loyalty/admin/seed-settings`,
    ADMIN_GIVE_POINTS: `${API_URL}/loyalty/admin/give-points`,
    ADMIN_TRANSACTIONS: `${API_URL}/loyalty/admin/debug-all`,
    ADMIN_REWARDS: `${API_URL}/loyalty/admin/rewards`,
    ADMIN_REDEMPTIONS: `${API_URL}/loyalty/admin/redemptions`,
  },
  WALLET: {
    ADMIN_ALL: `${API_URL}/wallet/admin/all`,
    ADMIN_DETAILS: (id) => `${API_URL}/wallet/admin/${id}`,
    ADMIN_ADJUST: `${API_URL}/wallet/admin/adjust`,
    ADMIN_RESET: (id) => `${API_URL}/wallet/admin/reset/${id}`,
  },
  SUPPORT: {
    ADMIN_ALL: `${API_URL}/support/admin/tickets`,
    ADMIN_NOTIFICATIONS: `${API_URL}/support/admin/notifications`,
    RESOLVE: (id) => `${API_URL}/support/tickets/${id}/resolve`,

    DETAILS: (id) => `${API_URL}/support/tickets/${id}`,
    MESSAGES: (id) => `${API_URL}/support/tickets/${id}/messages`,
  },
  REFUNDS: {
    base: `${API_URL}/admin/refunds`,
    stats: `${API_URL}/admin/refunds/stats`,
    request: (bookingId) => `${API_URL}/bookings/${bookingId}/refund-request`,
    approve: (id) => `${API_URL}/admin/refunds/${id}/approve`,
    reject: (id) => `${API_URL}/admin/refunds/${id}/reject`,
    detail: (id) => `${API_URL}/admin/refunds/${id}`,
  },
  COMMUNITY: {
    base: `${API_URL}/community`,
    USER_POSTS: (id) => `${API_URL}/community/posts/user/${id}`,
    POST_DETAIL: (id) => `${API_URL}/community/posts/${id}`,
    DELETE_POST: (id) => `${API_URL}/community/posts/${id}`,
    REPORTS: `${API_URL}/community/reports`,
    DELETE_REPORT: (id) => `${API_URL}/community/reports/${id}`,
  },
  SERVICE_AREAS: {
    base: `${API_URL}/service-areas`,
    seed: `${API_URL}/service-areas/seed`,
  },
  SENDBIRD: {
    CHANNELS: `${API_URL}/sendbird/channels`,
    MESSAGES: (channelUrl) => `${API_URL}/sendbird/channels/${channelUrl}/messages`,
  },
};

export default API_URL;
